import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import { connect } from 'react-redux'
import {compose, bindActionCreators} from 'redux'
import * as actions from '../../actions'

import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'


const styles = theme => ({
  page: {
    margin: 30,
    marginTop: 100,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  menuItem: {
    width: 100,
    height: 30,
    border: '4px solid green',
    margin: 10,
  },
  menuItemAdd: {
    width: 100,
    height: 30,
    border: '4px solid blue',
    // padding: 20,
    margin: 10,
    backgroundColor: 'rgba(0, 0, 255, 0.2)'
  },
  flex1: {
    flex: 1
  }
});

export class SpacesScreen extends Component {
  
  componentDidMount() {
    this.props.getSpaces()
  }

  goSpace = (space) => {
    console.log('Space: ', space)
  }

  newSpace = () => {
    console.log('New Space')
  }

  _renderNewButton = () => {
    const { classes } = this.props

    return (classes) && (
      <MenuItem key={'NEW'} className={classes.menuItemAdd} onClick={()=>this.newSpace()} component={Link} to={`/new`}>
        <Typography variant='button' align='center' className={classes.flex1}>
          Add New
        </Typography>
      </MenuItem>
    )
  }

  render() {
    const { spaces, classes } = this.props;

    return (spaces && spaces.allSpaces) ? (
      <div className={classes.page}>
        <Typography variant='headline'>
          Spaces
        </Typography>

        <div className={classes.container}>
        {this._renderNewButton()}
        {
          spaces.allSpaces.map(space => 
            <MenuItem key={space.prefix} className={classes.menuItem} onClick={()=>this.goSpace(space)} component={Link} to={`/spaces/${space.space_id}`}>
              <Typography variant='button' align='center' className={classes.flex1}>
                {space.title}
              </Typography>
            </MenuItem>
          )
        }
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    spaces: state.spaces
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch)
}

export default  compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SpacesScreen)



// WEBPACK FOOTER //
// ./src/components/spaces/SpacesScreen.js